import React from 'react';

import Notification from './components/Notification';
import ActivityScreenRecorder from './pages/FleetManagement/OrganizationMemberDetails/PatientActivity/components/ActivityScreenRecorder';
import AppRoutes from './routes';
import Style from './style';
import SegmentInit from './utils/segment';
import WsWrapper from './ws/wrapper';

const App: React.FC = () => {
    return (
        <>
            <SegmentInit />
            <Style />
            <WsWrapper />
            <ActivityScreenRecorder />
            <AppRoutes />
            <Notification />
        </>
    );
};

export default App;
